import { defineStore } from 'pinia';

interface User {
  id: number;
  account: string;
  username: string;
  email: string;
  phone: string;
  avatarUrl: string | null;
  vip: number;
  vipExpiresAt: string | null;
  status: string;
  emailVerified: boolean;
  phoneVerified: boolean;
  lastLoginAt: string;
  loginCount: number;
  createdAt: string;
}

interface AuthState {
  token: string | null;
  user: User | null;
}

export const useAuthStore = defineStore('auth', {
  state: (): AuthState => ({
    token: localStorage.getItem('token'),
    user: null
  }),

  getters: {
    isAuthenticated: (state) => !!state.token,
    currentUser: (state) => state.user
  },

  actions: {
    setToken(token: string) {
      this.token = token;
      localStorage.setItem('token', token);
    },

    setUser(user: User) {
      this.user = user;
    },

    logout() {
      this.token = null;
      this.user = null;
      localStorage.removeItem('token');
    }
  }
}); 